import { useEffect } from "react";

import { useLocation } from "react-router-dom";

export const useTrailingSlashFix = () => {
  const location = useLocation();

  useEffect(() => {
    const { pathname, search } = location;
    const hasTrailingSlash = pathname.endsWith("/");
    const hasExtension = /\.[a-z0-9]+$/i.test(pathname);

    if (!hasTrailingSlash && !hasExtension) {
      const newUrl = `${pathname}/` + (search || "");
      window.history.replaceState({}, "", newUrl);
    }
  }, [location]);
};
